import { formaters, integerCentToFrenchFinanString } from "vincent-utils";
import LockedBadge from "../../utils/components/LockedBadge.tsx";

interface HonorairesCompProps {
  _id: string;
  libellé: string;
  date: Date;
  montantCent: number;
  "n° de bordereau de banque"?: string;
  proposed: number[];
  combinaisonSelected: number | null;
  onSelectCombinaison: (number: number) => void;
  checked: boolean;
  onToggleCheck: () => void;
  locked?: boolean;
  disabled: boolean;
}

const HonorairesComp = (props: HonorairesCompProps) => {
  const bordereau = props["n° de bordereau de banque"];
  const {
    _id,
    date,
    libellé,
    montantCent,
    proposed,
    combinaisonSelected,
    onSelectCombinaison,
  } = props;
  const checkboxId = `honoraire-checkbox-${_id}`;
  const isInvolved = props.proposed.length > 0;
  const isLocked = props.locked === true;
  return (
    <li className="list-group-item">
      <div className="form-check">
        <input
          id={checkboxId}
          type="checkbox"
          className="form-check-input"
          checked={props.checked}
          onChange={props.onToggleCheck}
          disabled={props.disabled || isLocked}
          style={{ cursor: "pointer" }}
        />
        <label
          htmlFor={checkboxId}
          className={"form-check-label " + (isInvolved ? "text-primary" : "")}
          style={{ cursor: "pointer" }}
        >
          {formaters.formatDateAsDDN(date)} {libellé} - {bordereau}
          {" - "}
          {integerCentToFrenchFinanString(montantCent)}{" "}
          {isLocked ? <LockedBadge /> : null}
        </label>{" "}
        {proposed.map((number) => (
          <span key={"propBadgeKey" + number}>
            <button
              type="button"
              className={
                "badge border-0" +
                " " +
                (combinaisonSelected === number ? "bg-primary" : "bg-secondary")
              }
              disabled={props.disabled || isLocked}
              onClick={() => onSelectCombinaison(number)}
              style={{ cursor: "pointer" }}
            >
              {number}
            </button>{" "}
          </span>
        ))}
      </div>
    </li>
  );
};

export default HonorairesComp;
